import { wrappedApiGet, wrappedApiPost } from 'utils/http';
import {
  ClientNotificationSubscriptionRequest,
  ClientNotificationSubscriptionResponse,
} from '@payer-admin-ui/api/src/notifications/models';

export const notificationSubscriptionAPI = {
  get: async (): Promise<ClientNotificationSubscriptionResponse[]> => {
    return wrappedApiGet<ClientNotificationSubscriptionResponse[]>('/notifications-subscriptions').withObjectResponse();
  },

  upsert: async (request: ClientNotificationSubscriptionRequest): Promise<void> => {
    return wrappedApiPost('/notifications-subscriptions', {
      body: request,
    }).withEmptyResponse();
  },
};
